"use strict";

//code non-migré en typescript
module.exports = (function (helpers) {
    var enterKeyCode = 13;
    var escKeyCode = 27;

    helpers.escKeyCode = function () { return escKeyCode; }
    helpers.enterKeyCode = function () { return enterKeyCode; }

    /** OBSOLETE : Utiliser "utilities.printInfo","utilities.printWarning" ou "utilities.printError" */
    // var printTypes = {
    //     error: 'error',
    //     warning: 'warning',
    //     info: 'info'
    // };
    //helpers.printTypes = printTypes;
    // helpers.print = function (obj, printType) {
    //     printType = printType || printTypes.info;
    //     if (printType === printTypes.error)
    //         console.error(obj);
    //     else if (printType === printTypes.warning)
    //         console.warn(obj);
    //     else
    //         console.log(obj);
    // }

    helpers.getPosition = function (element) {
        var xPos = 0;
        var yPos = 0;

        while (element) {
            if (element.tagName.toLowerCase() === "body") {
                var el = document.documentElement;
                var xScroll = element.scrollLeft || el.scrollLeft;
                var yScroll = element.scrollTop || el.scrollTop;

                xPos += (element.offsetLeft - xScroll + element.clientLeft);
                yPos += (element.offsetTop - yScroll + element.clientTop);
            } else {
                xPos += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                yPos += (element.offsetTop - element.scrollTop + element.clientTop);
            }

            element = element.offsetParent;
        }

        return {
            x: xPos,
            y: yPos
        };
    }

    helpers.resetTextBox = function (inputTarget) {
        if (!inputTarget) throw "Le selecteur du/des champ(s) doit être défini.";
        $(inputTarget).val('');
    }

    helpers.isValidNas = function isNAS(n) { if (typeof n == 'number' && n >= 0 && n < 1000000000 && n % 1 == 0) n = ('0'.repeat(8) + String(n)).slice(-9); if (!/^[0-9]{3}[ -]?[0-9]{3}[ -]?[0-9]{3}$/.test(n = String(n))) return false; n = n.replace(/[^0-9]/g, ''); return [].map.call(n, function (v, k) { var m = (k % 2) + 1, v = parseInt(v) * m; if (v > 10) return 1 + (v % 10); return v; }).reduce(function (a, b) { return a + b; }, 0) % 10 == 0; }

    return helpers;
})({});